import { useTranslation } from 'react-i18next'
import { STAGE_TONE, TONE_CLASS } from './gtm-lead-stage'
import type { GtmLeadStage } from '@laplace/contracts'
import { cn } from '@/shared/lib/utils'

export function GtmStageBadge({
  stage,
  step,
}: {
  stage: GtmLeadStage
  step?: number
}) {
  const { t } = useTranslation('gtm')
  return (
    <span
      className={cn(
        'inline-flex items-center whitespace-nowrap rounded-full border px-2 py-0.5 text-xs font-medium',
        TONE_CLASS[STAGE_TONE[stage]],
      )}
    >
      {stage === 'contacted' && step
        ? t('ws_stageContactedStep', { step })
        : t(`ws_stage_${stage}`)}
    </span>
  )
}
